import * as ApiCaller from '../libs/httpRequests';

const prefix = 'Pasc';

export function DanhSachLoaiKyThuatXetNghiem(loai)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/DanhSachLoaiKyThuatXetNghiem?loai=${loai}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function TemplateCDHA(loai)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/TemplateCDHA/${loai}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function DanhSachThuocTinh(loai,config=false)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/DanhSachThuocTinh/${loai}?config=${config}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function LoaiVPCDHA(loai, keyword)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/LoaiVPCDHA/${loai}?keyword=${keyword}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function ThongTinDaKhamThai(idchidinh,loai,makt,ngay, maql , mabn )  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/ThongTinDaKhamThai?idchidinh=${idchidinh}&loai=${loai}&makt=${makt}&ngay=${ngay}&maql=${maql}&mabn=${mabn} `).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function DanhSachThucHien(loai,tungay,denngay,key,dathuchien)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/danhsachthuchien?loai=${loai}&tungay=${tungay}&denngay=${denngay}&key=${key}&dathuchien=${dathuchien}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function LuuSieuAmThai(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/LuuSieuAmThai`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function downloadVideo(maql,idcd, stt) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGetDownload(`${prefix}/downloadVideo?maql=${maql}&idcd=${idcd}&stt=${stt}`).then((respone) => {
            return resolve(respone)
        }).catch((err) => {
           return reject(err)
        })
    });
};

export function saveVideo(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPostFormData(`${prefix}/saveVideo`,data,true,true).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function getVideo(maql,idChiDinh)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/getVideo?maql=${maql}&idchidinh=${idChiDinh}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};
export function getdanhsachvideo(fromdate,todate,key)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/danhsachvideo?fromdate=${fromdate}&todate=${todate}&key=${key}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};
export function deleteVideo(maql,idcd, stt) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpDelete(`${prefix}/deleteVideo?maql=${maql}&idcd=${idcd}&stt=${stt}`).then((respone) => {
            return resolve(respone)
        }).catch((err) => {
           return reject(err)
        })
    });
};
export function saveImage(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPostFormData(`${prefix}/saveImage`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function loadImage(maql,idcd, filename) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGetDownload(`${prefix}/loadImage?maql=${maql}&idcd=${idcd}&filename=${filename}`).then((respone) => {
            return resolve(respone)
        }).catch((err) => {
           return reject(err)
        })
    });
};

export function ThemThuocTinh(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/ThemThuocTinh`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function SuaThuocTinh(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/SuaThuocTinh`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function DeleteCDHA(id)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpDelete(`${prefix}/DeleteCDHA/${id}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function DeleteCDHAType(id)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpDelete(`${prefix}/DeleteCDHAType/${id}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function DeleteCDHAKT(id)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpDelete(`${prefix}/DeleteCDHAKT/${id}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function InsertUpdateCDHA(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/InsertUpdateCDHA`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};


export function InsertUpdateCDHAType(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/InsertUpdateCDHAType`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function InsertUpdateCDHAKT(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/InsertUpdateCDHAKT`,data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function HideAutoRecordCDHAKT(idvp,auto)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/HideAutoRecordCDHAKT?idvp=${idvp}&auto=${auto}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function addForm(data)  {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/saveFormPACS`, data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function getListFormPACS(idvp){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/getlistFormPACS?idvp=${idvp}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function getFormPACSDetail(formid){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/getFormPACSDetail?id=${formid}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function updateThoigiantaikham(data){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/updateThoigiantaikham`, data).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function getListPacs(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/ListPacs`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function getPACSAppoimentDetail(id) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/PACSAppoimentDetail/${id}`).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function savePACSAppoiment(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/SavePACSAppoiment`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function getPACSTemplate(serviceId){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/GetListPACSTemplate?idvp=${serviceId}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function getPACSTemplateDetail(templateId){
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/GetPACSTemplateByIdvp?id=${templateId}`).then(respone =>{
            return resolve(respone) 
        }).catch(err =>{
            return reject(err) 
        })
    });
};

export function print(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/Print`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function printPacs(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/PrintPacs`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function printPacsHtmlToPdf(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/PrintPacsHtmlToPdf`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function printPacsToPdf(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPostDownload(`${prefix}/printPacsToPdf`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function ListPACSAppoimentDetailByManagementId(id) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpGet(`${prefix}/ListPACSAppoimentDetailByManagementId/${id}`).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};

export function ChangeCompletedStatus(data) {
    return new Promise((resolve, reject) => {
        return ApiCaller.httpPost(`${prefix}/ChangeCompletedStatus`, data).then(respone => {
            return resolve(respone)
        }).catch(err => {
            return reject(err)
        })
    });
};